/* eslint-disable max-len */

export default function GRReportInstanceStatusController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleDelete($event) {
    ssDialogService.dialogs.reports.deleteReportInstanceStatusDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Report Review?',
        message: `Are you sure you want to delete Report the Review performed by "${vm.reportInstanceStatus.createUser.fullName}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.reports.deleteReportInstanceStatusDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteReportInstanceStatus(vm.reportInstanceStatus.reportInstanceStatusId).then(() => {
      alerts.success('The Report review has been deleted successfully.');
      $rootScope.$broadcast('refreshReportStatus', { reportInstanceId: vm.reportInstanceStatus.reportInstanceId });
      _closeDeleteDialog();
    }).catch(() => {
      alerts.error('Error occurred while deleting the Report Review.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportInstanceStatusDialog);
  }
}

GRReportInstanceStatusController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
